import { render } from "./notification.vue?vue&type=template&id=70d5fef1"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"
script.render = render

export default script